/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    TicketTimeLimitOverrideTimeConfigItem,
    TicketTimeLimitOverrideTimeConfigItemFromJSON,
    TicketTimeLimitOverrideTimeConfigItemFromJSONTyped,
    TicketTimeLimitOverrideTimeConfigItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOListItem
 */
export interface TTLOListItem {
    /**
     * 
     * @type {string}
     * @memberof TTLOListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TTLOListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TTLOListItem
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TTLOListItem
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOListItem
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TTLOListItem
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TTLOListItem
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {TicketTimeLimitOverrideTimeConfigItem}
     * @memberof TTLOListItem
     */
    time?: TicketTimeLimitOverrideTimeConfigItem;
    /**
     * 
     * @type {number}
     * @memberof TTLOListItem
     */
    dayOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof TTLOListItem
     */
    offsetDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOListItem
     */
    overrideDays?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TTLOListItem
     */
    relevance?: number;
    /**
     * 
     * @type {string}
     * @memberof TTLOListItem
     */
    description?: string | null;
}

export function TTLOListItemFromJSON(json: any): TTLOListItem {
    return TTLOListItemFromJSONTyped(json, false);
}

export function TTLOListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'time': !exists(json, 'time') ? undefined : TicketTimeLimitOverrideTimeConfigItemFromJSON(json['time']),
        'dayOffset': !exists(json, 'dayOffset') ? undefined : json['dayOffset'],
        'offsetDays': !exists(json, 'offsetDays') ? undefined : json['offsetDays'],
        'overrideDays': !exists(json, 'overrideDays') ? undefined : json['overrideDays'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function TTLOListItemToJSON(value?: TTLOListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'accountCodes': value.accountCodes,
        'excludeAccountCodes': value.excludeAccountCodes,
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'time': TicketTimeLimitOverrideTimeConfigItemToJSON(value.time),
        'dayOffset': value.dayOffset,
        'offsetDays': value.offsetDays,
        'overrideDays': value.overrideDays,
        'allowEdit': value.allowEdit,
        'relevance': value.relevance,
        'description': value.description,
    };
}


